export function levelName(level_id: number, short = true): string | void {
  const levelNames: { [key: number]: string } = {
    [-4]: short ? 'PG' : 'Playgroup',
    [-3]: (short ? 'N' : 'Nursery ') + '1',
    [-2]: (short ? 'N' : 'Nursery ') + '2',
    [-1]: (short ? 'K' : 'Kindergarten ') + '1',
    0: (short ? 'K' : 'Kindergarten ') + '2',
    1: (short ? 'P' : 'Primary ') + '1',
    2: (short ? 'P' : 'Primary ') + '2',
    3: (short ? 'P' : 'Primary ') + '3',
    4: (short ? 'P' : 'Primary ') + '4',
    5: (short ? 'P' : 'Primary ') + '5',
    6: (short ? 'P' : 'Primary ') + '6',
    7: (short ? 'S' : 'Secondary ') + '1',
    8: (short ? 'S' : 'Secondary ') + '2',
    9: (short ? 'S' : 'Secondary ') + '3',
    10: (short ? 'S' : 'Secondary ') + '4',
    11: (short ? 'JC' : 'Junior College ') + '1',
    12: (short ? 'JC' : 'Junior College ') + '2',
    14: (short ? 'S' : 'Secondary ') + '5',
  };

  return levelNames[level_id];
}

export function levelNameMultiple(
  level: string[] | string,
  short: boolean = true,
  separator: string = ', ',
): string {
  const levelList: number[] = [];
  if (Array.isArray(level)) {
    levelList.push(...level.map(item => parseInt(item)));
  } else {
    levelList.push(...level.split(',').map(item => parseInt(item)));
  }

  return levelList
    .sort(function (a, b) {
      return a - b;
    })
    .map(item => levelName(item, short))
    .join(separator);
}
